export const vesTableContent = [
  ['A1', 'A1 ≤90', 'A1 =0', 'A1 =0', 'A1 =0', 'A1 =0', '$25,000', '-'],
  ['A2', '90< A2 ≤120', '0< A2 ≤0.024', '0< A2 ≤0.190', '0< A2 ≤0.009', '0.0< A2 ≤0.3', '$5,000', '-'], // @suppress longLineCheck
  ['B', '120< B ≤159', '0.024< B ≤0.029', '0.190< B ≤0.270', '0.009< B ≤0.018', '0.3< B ≤0.4', '$0', '$0'], // @suppress longLineCheck
  ['C1', '159< C1 ≤182', '0.029< C1 ≤0.040', '0.270< C1 ≤0.350', '0.018< C1 ≤0.022', '0.4< C1 ≤1.0', '-', '$15,000'], // @suppress longLineCheck
  ['C2', 'C2 >182', 'C2 >0.040', 'C2 >0.350', 'C2 >0.022', 'C2 >1.0', '-', '$25,000'], // @suppress longLineCheck
];
